// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--2Nnoq"};